export default {
  Issue_orders_products_warehouse_receipts_first_leg_shipments_automatically_adding_the_account_prefix_before_product_names:
    "下发订单，商品，入库单，头程，商品前面自动增加账号前缀",
  Retrieve_orders_First_leg_shipments_Warehouse_receipts_and_Returns_synchronize_inventory_based_on_inbound_and_outbound_logistics_flow:
    "获取订单，头程，入库单，退件，按照出入库流水同步库存",
  Remove_account_prefix_automatically_according_to_the_account_number:
    "按照账号自动去掉前缀",
  Missing_return_tracking_number: "缺少退回运单号",
  Batch_generation_of_return_orders_is_not_supported: "不支持批量生成退货单",
  No_product_details: "无商品明细",
  Confirm_deletion_of_custom_tag: "确认删除自定义标签",
  Please_enter_refund_amount: "请输入退款金额",
  This_setting_is_a_global_configuration_and_applies_to_all_SKUs:
    "此设置为全局配置，适用于所有SKU",
  Calculate_the_average_daily_sales_for_each_day_using_the_system:
    "以系统计算出各天数日均销量",
  Calculate_the_average_daily_sales_based_on_the_proportion_of_each_day_s_allocation:
    "根据设置各天数的占比计算出日均销量",
  custom: "自定义",
  percentagewise: "按百分比计算",
  formula_mode: "计算方式",
  custom_daily_average_sales: "自定义日均销量",
  custom_daily_average_days: "自定义日均天数",
  Please_enter_the_custom_daily_average_sales: "请输入自定义日均销量",
  Please_enter_the_custom_daily_average_days: "请输入自定义日均天数",
  daily_average_sales: "日均销量",
  proportion: "占比",
  Recent_7_days_daily_average_sales: "近7天日均销量",
  Recent_14_days_daily_average_sales: "近14天日均销量",
  Recent_30_days_daily_average_sales: "近30天日均销量",
  Recent_45_days_daily_average_sales: "近45天日均销量",
  Recent_60_days_daily_average_sales: "近60天日均销量",
  Recent_90_days_daily_average_sales: "近90天日均销量",
  Set_available_days_calculation_formula: "设置可售天数计算公式",
  This_batch_setting_will_cover_the_individual_settings_of_the_selected_SKUs_warning_stock:
    "此批量设置将覆盖已选SKU单独设置的预警库存",
  Warehouse_order_list_with_stage_equal_to_pending_or_processing_and_matching_SKU_total_quantity:
    "仓储订单列表中阶段等于：待审核，待处理，匹配的SKU的总数量",
  Set_custom_daily_average_sales: "设置自定义日均销量",
  Set_inventory_performance: "设置库存表现",
  The_earliest_inventory_record_for_this_product_upon_entry_into_the_warehouse:
    "此商品入库最早一条库存记录",
  In_the_current_time_minus_a_specified_number_of_days_and_the_inventory_quantity_is_greater_than_0:
    "在当前时间减去一个指定天数，并且库存数量大于0",
  Inventory_manage_kind_count: "盘点种数",
  measure: "测",
  mend: "补",
  The_following_orders_have_not_been_marked_for_evaluation:
    "以下订单未标记测评单",
  Please_mark_the_evaluation_form_first: "请先标记测评单",
  default: "默认",
  The_maximum_value_cannot_be_less_than_the_minimum_value:
    "最大值不能小于最小值",
  View_product_SKU_list: "查看商品SKU列表",
  New_product_judgment_rules: "新品判定规则",
  Based_on_the_current_date_calculate_the_starting_date_by_advancing_the_set_number_of_days_If_the_first_inventory_date_of_the_SKU_falls_within_the_range_from_starting_date_inclusive_to_current_date_inclusive_and_the_current_inventory_quantity_of_this_SKU_is_greater_than_0_then_it_is_determined_as_a_new_product:
    "以当前日期为基准，根据设置的天数向前推算得到起始日期，若SKU的首次入库日期落在「起始日期(含)」至「当前日期(含)」的区间内，且该SKU当前库存数量大于0，则判定为新品",
  Example_explanation: "示例说明",
  If_the_current_date_is_2026_7_16_and_the_set_days_are_10_the_start_date_calculated_by_counting_backward_is_2026_7_06_when_the_first_inventory_entry_date_of_the_SKU_falls_between_2026_7_06_inclusive_and_2026_7_16_inclusive_and_the_inventory_quantity_is_greater_than_0_the_SKU_is_identified_as_a_new_product:
    "若当前日期为2026-7-16，设置天数为10天，向前推算得到起始日期2026-7-06，当SKU首次入库日期处于2026-7-06(含) 至 2026-7-16(含) 之间，且库存数量大于0时，该SKU即为新品",
  Selected_criteria: "已选条件",
  have_or_not: "有/无",
  Return_Information: "退货信息",
  Refund_amount_range: "退款金额范围",
  Refund_amount_cannot_exceed_original: "退款金额不能大于原退款金额",
  Buyer_returned_quantity: "买家退回数量",
  Please_input_SKU_separated_by_a_line_break: "请输入SKU，换行隔开",
  Product_quantity_range: "商品数量范围",
  SystemSKU: "系统SKU",
  Seller_operation_deadline_time_range: "卖家操作截止时间范围",
  Seller_application_compensation_deadline_time_range:
    "卖家申请赔偿截止时间范围",
  Seller_submit_evidence_deadline_time_range: "卖家提交证据截止时间范围",
  Please_Select_Product_Processing_Scheme: "请选择商品处理方案",
  Please_fill_in_the_return_order_remark: "请填写退货单备注",
  Cannot_be_a_negative_number: "不能为负数",
  return_order_remark: "退货单备注",
  event_type: "事件类型",
  non_original_order_return_warehouse: "非原单退件收货仓库",
  returned_product_processing_scheme: "退货商品处理方案",
  inventory_total: "库存总量",
  unusable_inventory: "不可用库存",
  return_processing_inventory: "退货处理中库存",
  defective_inventory: "次品库存",
  in_transit_inventory: "在途库存",
  Has: "有",
  inventory_batch_number: "库存批次号",
  Total_inventory: "库存总量",
  Total_occupation_quantity: "总占用数量",
  available_quantity: "可用数量",
  unavailable_quantity: "不可用数量",
  cube: "立方",
  inventory_age: "库龄",
  inventory_type: "库存类型",
  Shelf_time: "上架时间",
  Total_defective_inventory: "总次品库存",
  Total_unavailable_inventory: "总不可用库存",
  Preparation_order_number: "备货单号",
  Total_number_of_prepared_products: "备货商品总数量",
  Total_varieties_of_prepared_products: "备货商品总种量",
  Total_cube_of_prepared_goods: "备货总立方",
  Total_weight_of_prepared_goods: "备货总重量",
  Plan_prepare_inventory: "计划备货总量",
  positionTransferMigration: "移仓迁出",
  goods_quantity_in_preparing_status_during_stocking_plan_phase:
    "备货单阶段:“备货中”的商品数量。",
  total_available_inventory_plus_total_occupied_inventory_plus_defective_inventory:
    "可用库存总量 + 占用库存总量 + 次品库存",
  return_order_quantity_of_pending_approval_pending_putaway_putaway_in_progress_qualified_goods_with_unfinished_putaway:
    "退货单：待审核，待上架，上架中，合格未完成上架的数量",
  inbound_order_unputaway_quantity_of_stages_pending_approval_approved_transit_warehouse_receiving_in_transit_last_mile_receiving_in_progress_last_mile_received_quality_inspection_in_progress_quality_inspected:
    "入库单：待审核，已审核，中转仓收货，运输中，尾程收货中，尾程已收货，质检中，已质检 阶段未上架的数量",
  EntryAndExitRecords: "查看库存详情",
  quarters: "季",
   days_or_months_or_quarters: "天/月/季",
   Days_Tasks_are_generated_at_intervals_of_specified_calendar_days_If_the_cycle_is_set_to_20_and_the_last_cycle_count_date_of_this_item_or_bin_location_was_2026_07_10_the_next_automatic_cycle_count_task_will_be_generated_on_2026_07_30:"天：按照间隔多少自然日生成任务，假设周期为 20，此商品或库位上次盘点时间是 2026-07-10，则 2026-07-30 才会再次自动生成盘点任务",
   Months_Tasks_are_generated_based_on_complete_calendar_months_If_the_cycle_is_set_to_2_and_the_last_cycle_count_date_of_this_item_or_bin_location_was_2026_07_10_the_next_automatic_cycle_count_task_will_be_generated_in_September:"月：将按照完整的自然月生成任务，假设周期为 2，此商品或库位上次盘点时间是 2026-07-10，则 9 月才会再次自动生成盘点任务",
   Quarters_Q1_covers_January_February_and_March_Q2_covers_April_May_and_June_Q3_covers_July_August_and_September_Q4_covers_October_November_and_December_If_the_cycle_is_set_to_1_and_the_last_cycle_count_date_of_this_item_or_bin_location_was_2026_07_10_the_next_automatic_cycle_count_task_will_be_generated_in_October:"季：一季度 Q1:1、2、3 月，二季度 Q2:4、5、6 月，三季度 Q3:7、8、9 月，四季度 Q4:10、11、12 月。假设周期为 1，此商品或库位上次盘点时间是 2026-07-10，则 10 月才会再次自动生成盘点任务",


   Upload_evidence: "上传证据",
  Activation_Phase: "激活阶段",
  Please_re_complete_the_receiving_and_quality_inspection_procedures:
    "请重新完成收货与质检操作",
  After_activation_all_receiving_and_quality_inspection_information_will_be_cleared_and_the_stage_will_be_changed_to_the_warehouse_receipt:
    "激活后会清空所有的收货与质检信息，入库单阶段改为",
  After_marking_as_abnormal_the_original_state_cannot_be_restored_after_reactivating_you_can_choose_to_activate_to_Pending_Review_or_Reviewed_or_Transit_Warehouse_Receipt_or_In_Transit_or_Tail_End_Receipting:
    "标记异常后无法恢复原来的状态，重新激活后，您可选择激活到待审核,已审核,中转仓收货,运输中，尾程收货中",
  Clear_all_the_receiving_and_quality_inspection_information_and_confirm_whether_to_adjust_to_the_abnormal_stage:
    "清除所有收货与质检信息，确认调整到异常阶段",
  entry_type: "入库类型",
  Review_time: "盘点时间",
  Withdraw_reason: "撤销原因",
  Transfer_out_of_warehouse: "移仓迁出",
  internalTransference: "内部调拨",
  mark_no_fee_deduction: "标记不扣费",
  Whether_the_marking_incurs_a_charge: "标记是否扣费",
  whether_to_deduct_fees: "是否扣费",
  please_upload: "请上传",
  file: "文件",
  No_charge: "是否不扣费",
  preFulfillment: "预先履约",
  Performance_Order_Number: "履约单号",
  Unmatched: "未匹配",
  in_hand: "处理中",
  It_has_been_completed: "已完结",
  Settings_Information: "设置信息",
  Automatic_task: "自动任务",
  Only_this_current_SKU_is_in_effect:"仅当前SKU生效",
  For_initiate_dispute_on_shopee_auto_fill_email_item: "用于 Shopee 发起争议自动填充邮箱项",
  The_order_does_not_support_partial_refund: "该订单暂不支持部分退款",
  Please_provide_related_evidence_to_refute_the_claim_or_obtain_compensation: "请提供相关证据以反驳买家/获取赔偿",
  Response_refund: "回应退款",
  Response_return: "回应退货",
  Provide_evidence: "提供证据",
  Verify_goods: "验证商品",
  Platform_approve_refund: "平台批准退款",
  Only_count_data_created_in_the_last_30_days: "仅统计创建时间近30天数据",

  Restore_global_settings:"恢复全局设置",
  confirm_whether_to_restore_to_global_custom_daily_sales_setting: "是否确认恢复为全局的自定义日均销量设置",
  This_is_a_global_setting_applicable_to_all_SKUs_if_you_need_to_configure_a_single_SKU_separately_please_go_to_the_SKU_operation_column_for_settings_individual_SKU_settings_take_priority_over_global_settings: "当前为全局配置，适用于所有SKU；如需单独配置某一SKU，请前往SKU操作列设置，单SKU设置优先级高于全局配置",
  Only_effective_for_the_current_SKU_this_setting_takes_priority_over_global_settings: "仅当前SKU生效，该设置优先级高于全局配置",
  Calculate_the_final_daily_average_sales_based_on_the_daily_average_sales_of_each_day_dimension_calculated_by_the_system_according_to_the_set_dimension_proportion: "以系统计算出的各天数日均销量维度为基数，按设置的维度占比计算最终日均销量",
  The_sum_of_percentages_must_be_equal_to_100: "百分比总和需等于100",
  Based_on_the_set_number_of_days_parameter_count_back_the_corresponding_number_of_days_from_today_statistics_all_sales_in_this_period_divide_the_cumulative_sales_by_the_number_of_days_to_get_the_average_daily_sales_for_this_dimension: "基于设置的天数参数，从今日往前倒推对应天数，统计该区间内的全部销量，用累计销量除以该天数，得到该维度的日均销量",
  Set_up_custom_average_daily_sales_calculation_method: "设置自定义日均销量计算方式",
  Enter_the_average_daily_sales_quantity: "输入日均销量数量",
  Custom_average_daily_sales_can_be_calculated_through_a_custom_formula_or_directly_use_the_value_set_individually_for_the_SKU_the_individually_set_value_will_be_displayed_prioritized: "自定义日均销量可通过自定义公式计算，也可直接使用SKU单独设置的数值。优先显示单独设置数值",
  Set_the_average_daily_sales: "设置日均销量",
  Divide_inventory_performance_by_the_warehouse_dimension_of_the_goods_statistics_will_be_made_every_early_morning_rule_changes_will_take_effect_the_next_day: "以商品的仓库维度划分库存表现，每天凌晨统计，修改规则后需第二天生效",
  fuzzy_query:"模糊查询",
  In_transit_inventory:"总在途库存",
  Edit_the_assessment_fee_of_all_selected_orders_the_existing_data_will_be_replaced:
    "编辑所有选中订单的评测费用，原来已有数据会被替换",
  Batch_modified_successfully: "批量修改成功",
  Batch_modify_assessment_fee: "批量修改评测费用",
  Set_up_order_evaluation_fee_and_product: "设置订单测评费和商品",
  When_an_order_is_marked_as_an_evaluation_order_and_an_evaluation_product_is_set_for_the_order_the_system_will_automatically_delete_all_items_in_the_order_and_add_one_evaluation_product_with_a_quantity_of_1_for_shipment_this_means_all_original_items_of_the_entire_order_are_replaced_by_this_single_evaluation_product: "当订单标记为评测订单，设置订单测评商品后，系统会自动将订单全部商品删除，同时添加一个评测商品且数量为 1 用于发货。相当于用一个评测商品替换了整单商品。",
  Submit_evaluation_fee: "提交测评费",
  Submit_evaluation_product: "提交测评商品",
  Submit_both: "合并提交",
  Mark_success_set_evaluation_now: "标记成功，是否立即设置测评费和商品？",
  marked:"有标记",
  noMarks:"无标记",
  Evaluation_Form:"测评单",
  System_return_order_already_generated:"已生成系统退件",
  Update_return_and_refund:"更新退货退款",
  Batch_generation_of_return_orders_requires_the_same_warehouse: "批量生成退货单,勾选数据的需要仓库相同",
  back_to_top: "回到顶部",
};
